import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { clearIframeUrl } from "slices/iframeSlice";
import { getEcho } from "services/echo";

const JoinRoomCall = () => {
  const { id } = useParams();
  const iframeUrl = useSelector((state) => state.iframe.iframeUrl);
  const dispatch = useDispatch();
  const [sessionEnded, setSessionEnded] = useState(false);

  useEffect(() => {
    if (!id) return;
    const echo = getEcho();
    const channelName = `appointment.${id}`;
    const channel = echo.channel(channelName);
    channel.listen(".session-ended", () => {
      dispatch(clearIframeUrl());
      setSessionEnded(true);
    });
    return () => {
      channel.stopListening(".session-ended");
      echo.leave(channelName);
    };
  }, [id, dispatch]);

  return (
    <div className="content" style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 0 }}>
      <div
        className="container-fluid d-flex flex-column align-items-center justify-content-center bg-light p-0"
        style={{ width: "100%", height: "calc(100vh - 100px)" }}
      >
        {iframeUrl && !sessionEnded ? (
          <iframe
            title="100ms-app"
            allow="camera *;microphone *;display-capture *"
            src={iframeUrl}
            className="w-100 h-100 border-0"
          ></iframe>
        ) : (
          <p>{sessionEnded ? "The session has been ended by the host." : "No video call in progress."}</p>
        )}
      </div>
    </div>
  );
};

export default JoinRoomCall;
